import * as React from 'react'
import { tw } from 'utils/classnames'

export function ToolHomeLayout({ children }: { children: React.ReactNode }) {
  return (
    <div
      className={tw(
        'flex h-full flex-col items-center justify-start gap-2 overflow-y-auto p-4 pb-24',
        'md:justify-center md:py-20',
        'lg:flex-row lg:gap-16 lg:px-12 lg:py-24',
      )}
    >
      {children}
    </div>
  )
}
